// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderPatientRequest {
    static getAttributeTypeMap() {
        return PharmacyCardFinderPatientRequest.attributeTypeMap;
    }
}
PharmacyCardFinderPatientRequest.discriminator = undefined;
PharmacyCardFinderPatientRequest.additionalProperties = false;
PharmacyCardFinderPatientRequest.attributeTypeMap = [
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "PharmacyCardFinderGender"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderPatientRequest.js.map